import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "completeWrapper",
  class: "flex-col view-wrapper"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = {
  key: 0,
  class: "postMsgs flex-col"
}
const _hoisted_5 = {
  class: "msg-name",
  notranslate: ""
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "complete-content flex-col"
}
const _hoisted_8 = { class: "participant-list flex-col" }
const _hoisted_9 = {
  class: "bold",
  notranslate: ""
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "bold"
}
const _hoisted_12 = { class: "participant-list flex-col" }
const _hoisted_13 = {
  class: "bold",
  notranslate: ""
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "waiver-link si-input flex-row" }
const _hoisted_16 = { notranslate: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, "Waiver complete" + _toDisplayString(_ctx.unassigned ? ':' : ' for:'), 1),
          (_ctx.postWaiverMsgs.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postWaiverMsgs, (msg, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(msg.Name), 1),
                    (msg.Message)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          innerHTML: msg.Message,
                          class: "client-msg"
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.participants.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bold" }, "You have successfully completed a waiver for the following guests:", -1)),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participants, (p, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(p.name), 1),
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(p.age) + " years old ", 1),
                      (!p.isParticipating)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " • Not participating"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              (_ctx.consents.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, "The following guests have completed their waivers:"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consents, (p, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(p.firstName) + " " + _toDisplayString(p.lastName), 1),
                    _createElementVNode("div", null, _toDisplayString(p.age) + " years old", 1)
                  ]))
                }), 128))
              ]),
              (!_ctx.wrapped)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "link-ins bold" }, "Do others in your party need to fill out a waiver? Share the link below.", -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.waiverUrl), 1),
                      _cache[3] || (_cache[3] = _createTextVNode()),
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.copyLinkUrl()), ["stop"])),
                        class: _normalizeClass({ 'copy-success': _ctx.linkCopied })
                      }, _toDisplayString(_ctx.linkCopied ? 'Link Copied' : 'Copy link'), 3)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "form-submit-btn bold",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.restartWaiver()), ["stop"]))
              }, "Fill out another waiver"),
              (_ctx.wrapped)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "form-submit-btn bold",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onDone()), ["stop"]))
                  }, "Done"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
}